import { Directive, HostListener, Input } from '@angular/core';

@Directive({ selector: '[appPreventCopy]' })
export class PreventCopyDirective {

     @Input() appPreventCopy = false;

     constructor() { }

     @HostListener('copy', ['$event'])
     blockCopy(e: ClipboardEvent): void {
     	if (this.appPreventCopy) {
     		e.preventDefault();
     	}
     }

     @HostListener('cut', ['$event'])
     blockCut(e: ClipboardEvent): void {
     	if (this.appPreventCopy) {
     		e.preventDefault();
     	}
     }
}
